/**
 * Per-page-load placeholder for the `ownerId` of optimistically-created
 * UserAnnotations. The real `ownerId` is the server's
 * `auth.accountId` — but we don't have access to that from the client
 * (the server resolves it from the auth token). For optimistic rows
 * we want a value that:
 *
 *   - is distinct from any real `Account.id` so a stray optimistic row
 *     can't be mistaken for a server-issued one,
 *   - satisfies the `UserAnnotation.ownerId` `AccountId` brand at compile
 *     time,
 *   - never reaches the server (the server stamps its own `ownerId`).
 *
 * Generated once per page-load. The placeholder is overwritten the
 * moment the server response replaces the optimistic row in the
 * collection — the row identity (`id`) is also replaced, so a stale
 * placeholder can't survive a successful create.
 *
 * Lives in its own module so the auth-context / store / future demo
 * scaffolds can import it without pulling in any localStorage stub
 * code (the original home was the local-storage shim, which is gone).
 */
import { generateId } from "@shared/types/id";
export const OPTIMISTIC_OWNER_PLACEHOLDER = `acct_optimistic_pending_${generateId("userAnnotation").slice(4)}`;
